import { render, staticRenderFns } from "./disanfang.vue?vue&type=template&id=629606e6&scoped=true&"
import script from "./disanfang.vue?vue&type=script&lang=js&"
export * from "./disanfang.vue?vue&type=script&lang=js&"
import style0 from "./disanfang.vue?vue&type=style&index=0&id=629606e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629606e6",
  null
  
)

export default component.exports